import type { ListTutorStageCategory } from '@shared/model'

import { TutorKanbanStage } from '@brighterly/lib-core-types/tutor-kanban/enums'

const STAGE_CATEGORY_KEY_FALLBACKS: Partial<Record<TutorKanbanStage, keyof ListTutorStageCategory>> = {
  [TutorKanbanStage.ProbationFailed]: 'exit_decision_request',
  [TutorKanbanStage.ExitInProgress]: 'exit_decision_request',
  [TutorKanbanStage.ExitFinished]: 'exit_decision_request',
}

const getTutorStageCategoryKeys = (stage: string | null): (keyof ListTutorStageCategory)[] => {
  if (!stage) return []

  const stageKey = stage.toLowerCase() as keyof ListTutorStageCategory
  const fallbackKey = STAGE_CATEGORY_KEY_FALLBACKS[stage as TutorKanbanStage]

  return fallbackKey && fallbackKey !== stageKey
    ? [stageKey, fallbackKey]
    : [stageKey]
}

export const getTutorStageCategories = (
  stage: string | null,
  list: ListTutorStageCategory | undefined,
): Record<string, string> => {
  if (!list) return {}

  for (const key of getTutorStageCategoryKeys(stage)) {
    const categories = list[key]
    if (categories && Object.keys(categories).length > 0) return categories
  }

  return {}
}
